import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import parse from 'react-html-parser';
import {
  Button,
  ButtonsContainer,
  Container,
  Content,
  ContentWrapper,
  SubTitle,
  Title,
  Wrapper,
} from './Styles';
import { handleAcceptCookies } from '../../utils/handleAcceptCookies';
import Layout from '../../layout';
import { useDispatch } from 'react-redux';
import { navigationUrl } from '../../store/analytic/actions';

export default function CookiesTerms() {
  const history = useHistory();
  const dispatch = useDispatch();
  const termsRef = useRef<HTMLDivElement>(null);

  const [buttonDisabled, setButtonDisabled] = useState(true);

  const terms = useSelector(
    (state: ApplicationState) => state.config.politicaPrivacidade
  );

  function handleScroll(): void {
    if (
      termsRef.current &&
      Math.ceil(termsRef.current.scrollHeight - termsRef.current.scrollTop) ===
        termsRef.current.clientHeight
    ) {
      setButtonDisabled(false);
    }
  }

  function handleClick() {
    handleAcceptCookies();
    history.goBack();
  }

  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const query = '(min-width: 500px)';
    const handler = (e: MediaQueryListEvent) => setMobile(e.matches);
    const matcher = window.matchMedia(query);
    matcher.addEventListener('change', handler);
    setMobile(matcher.matches);

    dispatch(
      navigationUrl.request({
        action: '/termosPolitica',
      })
    );

    return () => matcher.removeEventListener('change', handler);
  }, [dispatch]);

  useEffect(() => {
    if (
      termsRef.current &&
      Math.ceil(termsRef.current.scrollHeight - termsRef.current.scrollTop) ===
        termsRef.current.clientHeight
    ) {
      setButtonDisabled(false);
    }
  }, [terms]);

  useEffect(() => {
    termsRef.current?.addEventListener('scroll', handleScroll);
    termsRef.current?.addEventListener('wheel', handleScroll);

    return () => {
      termsRef.current?.removeEventListener('scroll', handleScroll);
      termsRef.current?.removeEventListener('wheel', handleScroll);
    };
  }, [termsRef]);

  return (
    <Layout>
      <Wrapper>
        <Container>
          <Title>Política de Privacidade LGPD</Title>
          <SubTitle>
            Leia atentamente a Política de Privacidade LGPD, após concordar
            clicando no botão ao final dos termos você poderá prosseguir.
          </SubTitle>
          <ContentWrapper>
            <Content ref={termsRef}>
              {terms ? parse(terms) : <p>Carregando...</p>}
            </Content>
          </ContentWrapper>
          <ButtonsContainer>
            <Button className='normal' onClick={history.goBack}>
              CANCELAR
            </Button>
            <Button
              onClick={handleClick}
              disabled={buttonDisabled}
              className='agree'
              title={buttonDisabled ? 'Favor ler todo o documento' : ''}
            >
              CONCORDAR{mobile && ' E CONTINUAR'}
            </Button>
          </ButtonsContainer>
        </Container>
      </Wrapper>
    </Layout>
  );
}
